var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024.0005 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450.948 0C202.302 0 0 202.304 0 450.95c0 248.66 202.302 450.947 450.948 450.947 248.66 0 450.948-202.288 450.948-450.948C901.896 202.302 699.608 0 450.948 0zm0 818.647c-202.746 0-367.696-164.95-367.696-367.696S248.202 83.254 450.948 83.254s367.696 164.95 367.696 367.696-164.95 367.697-367.696 367.697zm560.856 134.298L773.148 714.29c-16.262-16.263-42.598-16.263-58.86 0-16.262 16.247-16.262 42.61 0 58.86l238.656 238.655c8.13 8.13 18.774 12.196 29.43 12.196 10.642 0 21.298-4.065 29.43-12.195 16.262-16.248 16.262-42.612 0-58.86z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.e789372ee4fb42183f3cc3beeaadb5c1.svg";
export { ForwardRef as ReactComponent };